import { APIFailureAction, APIRequestAction, APISuccessAction } from "@/mk2/helpers/action";
import { NormalizedResponse } from "@/mk2/helpers/api";

///////////////////////////////////////////////////////////////////
// Request token

export const PHONE_VERIFICATION_REQUEST_TOKEN_TRIGGER = "PHONE_VERIFICATION_REQUEST_TOKEN_TRIGGER";
export interface PhoneVerificationRequestTokenTriggerAction {
    readonly type: typeof PHONE_VERIFICATION_REQUEST_TOKEN_TRIGGER;
    readonly countryPrefix: string;
    readonly rawPhoneNumber: string;
    readonly resend: boolean;
}

export const PHONE_VERIFICATION_REQUEST_TOKEN_REQUEST = "PHONE_VERIFICATION_REQUEST_TOKEN_REQUEST";
export interface PhoneVerificationRequestTokenRequestAction extends APIRequestAction {
    readonly type: typeof PHONE_VERIFICATION_REQUEST_TOKEN_REQUEST;
    readonly countryPrefix: string;
    readonly rawPhoneNumber: string;
}

export const PHONE_VERIFICATION_REQUEST_TOKEN_SUCCESS = "PHONE_VERIFICATION_REQUEST_TOKEN_SUCCESS";
export interface PhoneVerificationRequestTokenNormalizedResponse extends NormalizedResponse {
    readonly result: { fullPhoneNumber: string };
}
export interface PhoneVerificationRequestTokenSuccessAction extends APISuccessAction<PhoneVerificationRequestTokenNormalizedResponse> {
    readonly type: typeof PHONE_VERIFICATION_REQUEST_TOKEN_SUCCESS;
    readonly countryPrefix: string;
    readonly rawPhoneNumber: string;
}

export const PHONE_VERIFICATION_REQUEST_TOKEN_FAILURE = "PHONE_VERIFICATION_REQUEST_TOKEN_FAILURE";
export interface PhoneVerificationRequestTokenFailureAction extends APIFailureAction {
    readonly type: typeof PHONE_VERIFICATION_REQUEST_TOKEN_FAILURE;
    readonly countryPrefix: string;
    readonly rawPhoneNumber: string;
}

export const phoneVerificationRequestTokenTrigger = (
    countryPrefix: string,
    rawPhoneNumber: string,
    resend: boolean,
): PhoneVerificationRequestTokenTriggerAction => ({
    type: PHONE_VERIFICATION_REQUEST_TOKEN_TRIGGER,
    countryPrefix,
    rawPhoneNumber,
    resend,
});

export const phoneVerificationRequestTokenApi = {
    request: (
        countryPrefix: string,
        rawPhoneNumber: string,
    ): PhoneVerificationRequestTokenRequestAction => ({
        type: PHONE_VERIFICATION_REQUEST_TOKEN_REQUEST,
        countryPrefix,
        rawPhoneNumber,
    }),
    success: (
        countryPrefix: string,
        rawPhoneNumber: string,
        response: PhoneVerificationRequestTokenNormalizedResponse,
    ): PhoneVerificationRequestTokenSuccessAction => ({
        type: PHONE_VERIFICATION_REQUEST_TOKEN_SUCCESS,
        countryPrefix,
        rawPhoneNumber,
        response,
    }),
    failure: (
        countryPrefix: string,
        rawPhoneNumber: string,
        error: string,
    ): PhoneVerificationRequestTokenFailureAction => ({
        type: PHONE_VERIFICATION_REQUEST_TOKEN_FAILURE,
        countryPrefix,
        rawPhoneNumber,
        error,
    }),
};

///////////////////////////////////////////////////////////////////
// Validate token

export const PHONE_VERIFICATION_VALIDATE_TOKEN_TRIGGER =
    "PHONE_VERIFICATION_VALIDATE_TOKEN_TRIGGER";
export interface PhoneVerificationValidateTokenTriggerAction {
    readonly type: typeof PHONE_VERIFICATION_VALIDATE_TOKEN_TRIGGER;
    readonly token: string;
    readonly fullPhoneNumber: string;
}

export const PHONE_VERIFICATION_VALIDATE_TOKEN_REQUEST =
    "PHONE_VERIFICATION_VALIDATE_TOKEN_REQUEST";
export interface PhoneVerificationValidateTokenRequestAction extends APIRequestAction {
    readonly type: typeof PHONE_VERIFICATION_VALIDATE_TOKEN_REQUEST;
    readonly token: string;
    readonly fullPhoneNumber: string;
}

export const PHONE_VERIFICATION_VALIDATE_TOKEN_SUCCESS =
    "PHONE_VERIFICATION_VALIDATE_TOKEN_SUCCESS";
export interface PhoneVerificationValidateTokenNormalizedResponse extends NormalizedResponse {
    readonly result: {};
}
export interface PhoneVerificationValidateTokenSuccessAction extends APISuccessAction<PhoneVerificationValidateTokenNormalizedResponse> {
    readonly type: typeof PHONE_VERIFICATION_VALIDATE_TOKEN_SUCCESS;
    readonly token: string;
    readonly fullPhoneNumber: string;
}

export const PHONE_VERIFICATION_VALIDATE_TOKEN_FAILURE =
    "PHONE_VERIFICATION_VALIDATE_TOKEN_FAILURE";
export interface PhoneVerificationValidateTokenFailureAction extends APIFailureAction {
    readonly type: typeof PHONE_VERIFICATION_VALIDATE_TOKEN_FAILURE;
    readonly token: string;
    readonly fullPhoneNumber: string;
}

export const phoneVerificationValidateTokenTrigger = (
    token: string,
    fullPhoneNumber: string,
): PhoneVerificationValidateTokenTriggerAction => ({
    type: PHONE_VERIFICATION_VALIDATE_TOKEN_TRIGGER,
    token,
    fullPhoneNumber,
});

export const phoneVerificationValidateTokenApi = {
    request: (
        token: string,
        fullPhoneNumber: string,
    ): PhoneVerificationValidateTokenRequestAction => ({
        type: PHONE_VERIFICATION_VALIDATE_TOKEN_REQUEST,
        token,
        fullPhoneNumber,
    }),
    success: (
        token: string,
        fullPhoneNumber: string,
        response: PhoneVerificationValidateTokenNormalizedResponse,
    ): PhoneVerificationValidateTokenSuccessAction => ({
        type: PHONE_VERIFICATION_VALIDATE_TOKEN_SUCCESS,
        token,
        fullPhoneNumber,
        response,
    }),
    failure: (
        token: string,
        fullPhoneNumber: string,
        error: string,
    ): PhoneVerificationValidateTokenFailureAction => ({
        type: PHONE_VERIFICATION_VALIDATE_TOKEN_FAILURE,
        token,
        fullPhoneNumber,
        error,
    }),
};
